// Add 'and' conjunction
// Eg: [1, 2, 3] => '1, 2 and 3'

const andConjunction = (arr) => {
  const arrLength = arr.length;

  if (arrLength < 2) {
    return `${arr[0]}`;
  }

  return `${arr.slice(0, -1).join(', ')} and ${arr[arrLength - 1]}`;
};

export default andConjunction;
